<div [ngClass]="[kind === WebsiteBlockTextAndMediaType.GallerySquareAccentColumn || kind === WebsiteBlockTextAndMediaType.GalleryCircleAccentColumn ? 'scss-block-color-variable-font': '',
                kind === WebsiteBlockTextAndMediaType.GallerySquareColumn || kind === WebsiteBlockTextAndMediaType.GalleryCircleColumn ||
                kind === WebsiteBlockTextAndMediaType.GallerySquareCardColumn || kind === WebsiteBlockTextAndMediaType.GalleryCircleCardColumn ? 'scss-website-background-color' : '']">
    @switch (Scope.websiteMode) {
        @case (WebsiteMode.Live) {
            <div class="position-relative design-block">
                <ng-container *ngTemplateOutlet="blockContent"></ng-container>
            </div>
        }
        @case (WebsiteMode.ReadOnly) {
            <div class="position-relative design-block">
                <ng-container *ngTemplateOutlet="blockContent"></ng-container>
            </div>
        }
        @case (WebsiteMode.Preview) {
            <lib-design-blocks-action-menu>
                <ng-container *ngTemplateOutlet="blockContent"></ng-container>
            </lib-design-blocks-action-menu>
        }
    }
</div>

<ng-template #blockContent>
    <div class="d-flex flex-column gallery-column-block w-100"
        [ngClass]="{'scss-block-background-color-variable':
            kind === WebsiteBlockTextAndMediaType.GallerySquareAccentColumn ||
            kind === WebsiteBlockTextAndMediaType.GalleryCircleAccentColumn ||
            kind === WebsiteBlockTextAndMediaType.GallerySquareCardColumn ||
            kind === WebsiteBlockTextAndMediaType.GalleryCircleCardColumn}">

        @if (hasHeader) {
            <h2 class="text-center scss-website-block-customized-heading-font">
                <ng-content select="[header]"></ng-content>
            </h2>
        }
        <div class="w-100 d-flex justify-content-center gallery-column-block-items">
            <ng-content></ng-content>
        </div>
    </div>
</ng-template>